// __APP_ENV__ is an optional compile-time object injected by webpack's
// DefinePlugin (see webpack.dev.config.js). We declare it so TypeScript
// doesn't complain when the token is referenced.
declare const __APP_ENV__: Record<string, any> | undefined;

export function getEnv(): Record<string, any> {
    // Purpose: return environment configuration for the app.
    //
    // Notes:
    //  - Webpack's DefinePlugin commonly injects values for expressions like
    //      process.env.RUNNING_ON_NODE
    //    as literals at build time. Because that replacement happens at build
    //    time, reading `process.env` as a plain object in the browser will not
    //    include those values unless we explicitly reference them here.
    //  - This function builds a small object that (a) uses the compile-time
    //    replaced tokens (e.g. process.env.RUNNING_ON_NODE) and (b) falls back
    //    to the actual runtime process.env when available.

    try {
        // Prefer a single compile-time object `__APP_ENV__` if webpack
        // provided it. This avoids defining individual keys in this file and
        // keeps all environment values in one place (webpack config).
        const compiled = (typeof __APP_ENV__ !== 'undefined') ? __APP_ENV__ : undefined;

        // console.log("Compiled ENV:", compiled);

        // If there's a real runtime process.env (e.g. Node or a dev shim) use
        // that as well — merge so runtime env can supplement or override.
        const runtime = (typeof process !== 'undefined' && process && process.env)
            ? process.env as Record<string, any>
            : {};

        // Merge results with runtime taking precedence (runtime overrides
        // compile-time values if both exist). Return empty object on failure.
        return Object.assign({}, compiled || {}, runtime);
    } catch (error) {
        return {};
    }
}